import { useRouter } from 'next/router';
import { QuizLogo } from '@/components';
import { trackGnbAnalytics } from '@/layout/Header';
import { useUser } from '@/lib/auth';
import { CLASSROOM_ROUTES } from '@/shared/consts/routes';
export const HomeLogo = ({
  location,
  isSmall,
  showFullLogoFromTabletSm,
  redirectUrl = '/landing',
  className
}: {
  location: 'header' | 'play';
  isSmall?: boolean;
  showFullLogoFromTabletSm?: boolean;
  redirectUrl?: string;
  className?: string;
}) => {
  const router = useRouter();
  const {
    user
  } = useUser();

  // 학생에게 '홈' 은 공개 퀴즈(/public)나 랜딩이 아니라 자기 클래스다.
  // 상세 프로필·아바타 꾸미기에서 클래스로 돌아갈 경로가 없다는 제보가 있어
  // 페이지별 redirectUrl 대신 역할 기준으로 덮어쓴다.
  const isStudent = user?.type?.toLowerCase() === 'student';
  const homeUrl = isStudent ? CLASSROOM_ROUTES.list() : redirectUrl;
  const goHome = () => {
    trackGnbAnalytics('home', location);
    void router.push(homeUrl);
  };
  if (isSmall) {
    return <img className={'size-[24px] cursor-pointer'} onClick={goHome} src="/assets/logo_small_q.svg" alt="" />;
  }
  return <QuizLogo className={className} showFullLogoFromTabletSm={showFullLogoFromTabletSm} onClick={goHome} data-sentry-element="QuizLogo" data-sentry-component="HomeLogo" data-sentry-source-file="HomeLogo.tsx" />;
};